import { reduceToArray } from '../../../../utils/reduce-to-array';
import { getOrderRelatedShowtimeById } from './get-order-related-showtime-by-id';
export const getOrderRelatedShowtimesByIds = (showtimeIds) => reduceToArray(showtimeIds, getOrderRelatedShowtimeById);
